import request from '@/router/axios'

//登录
export const userLogin = (params) => {
  return request({
    url: '/api/wx/gzhLogin',
    method: 'get',
    params,
    headers: {
      noToken: true
    }
  })
}

//  绑定手机号
export const phoneBind = (data) => {
  return request({
    url: '/api/wx/getWxGzhPhoneNumber',
    method: 'post',
    data,
    headers: {
      noToken: true
    }
  })
}
//  修改用户信息
export const updateWxName = (params) => {
  return request({
    url: '/api/wx/updateWxName',
    method: 'get',
    params
  })
}

// 获取墓位列表
export function getTombSiteList(pageNum, pageSize, params) {
  return request({
    url: '/api/admin/userGrave/graveList',
    method: 'get',
    params: { pageNum, pageSize, ...params }
  })
}

// 获取当前用户墓位列表
export function getUserGraveList(pageNum, pageSize, params) {
  return request({
    url: '/api/admin/userGrave/list',
    method: 'get',
    params: { pageNum, pageSize, ...params }
  })
}

// 绑定墓位
export function setUserGrave(data) {
  return request({
    url: '/api/admin/userGrave',
    method: 'post',
    data
  })
}

// 解绑墓位
export function unbindGrave(id) {
  return request({
    url: `/api/admin/userGrave/${id}`,
    method: 'delete'
  })
}

// 字典
export function getDict(dictType) {
  return request({
    url: `/api/system/dict/data/type/` + dictType,
    method: 'get'
  })
}
